function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import * as React from 'react';

var InlineSvg = function (_React$Component) {
  _inherits(InlineSvg, _React$Component);

  function InlineSvg() {
    _classCallCheck(this, InlineSvg);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  InlineSvg.prototype.render = function render() {
    var _props = this.props,
        name = _props.name,
        _props$colour = _props.colour,
        colour = _props$colour === undefined ? 'cyan' : _props$colour;
    var colourHex = void 0;

    switch (colour) {
      case 'cyan':
        colourHex = '#00aec7';
        break;

      case 'deepCyan':
        colourHex = '#0f849e';
        break;

      case 'teal':
        colourHex = '#00b398';
        break;

      case 'blue':
        colourHex = '#004b87';
        break;

      case 'white':
        colourHex = '#ffffff';
        break;

      case 'lightCyan':
        colourHex = '#7FD1E3';
        break;

      case 'grey':
        colourHex = '#646F80';
        break;

      default:
        colourHex = '#00aec7';
      // cyan
    }

    switch (name) {
      case 'gear':
        return React.createElement('svg', {
          xmlns: 'http://www.w3.org/2000/svg',
          width: '24',
          height: '24',
          viewBox: '0 0 24 24'
        }, React.createElement('path', {
          d: 'M24 13.616v-3.232c-1.651-.587-2.694-.752-3.219-2.019v-.001c-.527-1.271.1-2.134.847-3.707l-2.285-2.285c-1.561.742-2.433 1.375-3.707.847h-.001c-1.269-.526-1.435-1.576-2.019-3.219h-3.232c-.582 1.635-.749 2.692-2.019 3.219h-.001c-1.271.528-2.132-.098-3.707-.847l-2.285 2.285c.745 1.568 1.375 2.434.847 3.707-.527 1.271-1.584 1.438-3.219 2.02v3.232c1.632.58 2.692.749 3.219 2.019.53 1.282-.114 2.166-.847 3.707l2.285 2.286c1.562-.743 2.434-1.375 3.707-.847h.001c1.27.526 1.436 1.579 2.019 3.219h3.232c.582-1.636.75-2.69 2.027-3.222h.001c1.262-.524 2.12.101 3.698.851l2.285-2.286c-.744-1.563-1.375-2.433-.848-3.706.527-1.271 1.588-1.44 3.221-2.021zm-12 2.384c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z',
          fill: colourHex
        }));

      case 'logout':
        return React.createElement('svg', {
          xmlns: 'http://www.w3.org/2000/svg',
          width: '24',
          height: '24',
          viewBox: '0 0 24 24'
        }, React.createElement('path', {
          d: 'M16 9v-4l8 7-8 7v-4h-8v-6h8zm-16-7v20h14v-2h-12v-16h12v-2h-14z',
          fill: colourHex
        }));

      case 'nineDot':
        return React.createElement('svg', {
          xmlns: 'http://www.w3.org/2000/svg',
          width: '38',
          height: '38',
          viewBox: '0 0 38 38'
        }, React.createElement('g', {
          fill: 'none',
          fillRule: 'evenodd'
        }, React.createElement('rect', {
          width: '38',
          height: '38',
          fill: '#646F80',
          rx: '2'
        }), React.createElement('path', {
          stroke: '#FFF',
          strokeLinecap: 'square',
          strokeWidth: '3',
          d: 'M12 1.49642875L12 36.5M26 .496621776L26 37.5M36.5033332 26L.496528267 26M36.5034717 13L.496666815 13',
          fill: colourHex
        })));

      case 'userIcon':
        return React.createElement('svg', {
          xmlns: 'http://www.w3.org/2000/svg',
          width: '24',
          height: '24',
          viewBox: '0 0 24 24'
        }, React.createElement('path', {
          d: 'M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm7.753 18.305c-.261-.586-.789-.991-1.871-1.241-2.293-.529-4.428-.993-3.393-2.945 3.145-5.942.833-9.119-2.489-9.119-3.388 0-5.644 3.299-2.489 9.119 1.066 1.964-1.148 2.427-3.393 2.945-1.084.25-1.608.658-1.867 1.246-1.405-1.723-2.251-3.919-2.251-6.31 0-5.514 4.486-10 10-10s10 4.486 10 10c0 2.389-.845 4.583-2.247 6.305z',
          fill: colourHex
        }));

      case 'dropDownArrow':
        return React.createElement('svg', {
          className: this.props.className,
          xmlns: 'http://www.w4.org/2000/svg',
          width: '16',
          height: '8',
          viewBox: '0 0 16 8'
        }, React.createElement('polygon', {
          fill: '#D0D5DC',
          fillRule: 'evenodd',
          points: '1565 59 1573 67 1557 67',
          transform: 'matrix(-1 0 0 1 1573 -59)'
        }));

      default:
        return React.createElement('strong', null, 'Error: no case in InlineSVG for ', name);
    }
  };

  return InlineSvg;
}(React.Component);

export default InlineSvg;